import { useMutation } from '@tanstack/react-query';
import { useSnapshot } from 'valtio/react';

import { contractManager, reloadContract } from '@paid-ui/models/contract';
import { useToast } from '@paid-ui/ui/toast';
import { request } from '@paid-ui/utils/axios';

interface UpdateTimelinesBody {
  initialConstructionDays: number;
}

export const useTimelinesUpdate = () => {
  const toast = useToast();
  const { id: contractId } = useSnapshot(contractManager);

  return useMutation({
    mutationKey: ['UpdateTimelines'],
    mutationFn: async (body: UpdateTimelinesBody) => {
      await request.put<null>(`/contracts/${contractId}/timelines`, body);
    },
    onSuccess() {
      reloadContract();
      toast.success('Timelines updated.');
    },
    onError(err) {
      toast.error(err instanceof Error ? err.message : 'Failed to update timelines.');
    },
  });
};
